export default {
  ResetPwdSuccess: 'Reset password success!',
  UserName: 'Username',
  CName: 'Show Name',
  InitPwd: 'Initial password',
  ResetPwd: 'Reset password',
  EditSuccess: 'Edit success',
  CreateSuccess: 'Created successfully',
  SubUserManage: 'Sub-user manage',
  YouCanCreateSubUser: 'You can create one or more sub-users to authorize the gateway device associated with your account, allowing it to access the associated gateway device related configuration and use related features.',
  NewUser: 'New user',
  SearchUser: 'Search username/show name/authorization gateway/branch',
  PleaseEnterName: 'Please enter username',
  AuthGateway: 'Authorize Gateway',
  SpecialReminder: 'Special reminder: Cancellation of the authorized gateway will invalid the associated gateway created by the subuser such as access control rules, qos policies, traffic control, etc.',
  UserNameTest: 'User name consists of 3 to 16 English or number characters',
  CNameTest: 'Show name consists of 2 to 15 Chinese or English or number characters',
  PleaseGateway: 'Please associate at least one gateway',
  AddChildUser: 'Please add one sub-account',
  EditChildUser: 'Edit sub-account',
  AreYouSureResetPwd: 'Are you sure you want to reset password?',
  Manageable: 'Manageable',
  ViewOnly: 'ViewOnly',
}